export default __webpack_public_path__ + "static/media/es-ct.208ddf7a.svg";